import React from 'react'
import Image from "../../asserts/images/e.png" ;

function Guichet() {
  return (
    <div className='contentimagesDirection'>
    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
              <p>Guichet : <br/> Bouafsoun Bassem </p>
              <p id='email1'><i class="fa-regular fa-envelope"></i> bassem.bouafsoun@isimm.u-monastir.tn</p>
            </div>
    </div>

    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
              <p>Guichet : <br/> Lotfi Marmouch</p>
              <p id='email1'><i class="fa-regular fa-envelope"></i> lotfi.marmouch@isimm.u-monastir.tn</p>
            </div>
    </div>
        
       
    </div>
  )
}

export default Guichet